import React, { useEffect, useState } from 'react'
import { motion as m } from 'framer-motion'
import store from '../store/store'
import Cards from '../components/Cards'
import Results from '../components/Results'

export default function Searchpage() {
  const isMenuOpen = store((state) => state.isMenuOpen)
  const setIsMenuOpen = store((state) => state.setIsMenuOpen)

  // auto close the menu once the page is loaded
  useEffect(() => {
    if (isMenuOpen) {
      setIsMenuOpen(false)
    }
  },[])

  // Scroll to the top of the page when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const animDuration = 0.4
  
  const spring = {
    type: "spring",
    damping: 20,
    stiffness: 600,
  };

  const containerVar = {
    initial: {
      x:'-100%',
      transition: {
        duration: animDuration,
      },
    },
    animate: {
      x: '0%',
      transition: {
        duration: animDuration,
      },
    },
    exit: {
        x: '-100%',
        transition: {
            duration: animDuration,
          },
    },
  }

  return (
    <main>
      <m.div
        id='home_container'
        variants={containerVar}
        initial="initial"
        animate="animate"
        exit="exit"
      >
        <Results />
        <Cards />
      </m.div>
    </main>
  )
}
